<template>
    <div class="col-12">

        <step-progress :donesteps="_currentStep"/>

        <component :is="_stepView" v-on:stepdone="_stepdone" v-on:abbort="_abbort"/>

    </div>
</template>

<script>

    import Firststep from './steps/Firststep'
    import Secondstep from './steps/Secondstep'
    import Thirdstep from './steps/Thirdstep'
    import Forthstep from './steps/Forthstep'
    import StepProgress from '../StepProgress'

    export default {
        name: "problem-wizard",

        data: () => ({
        }),

        components: {
            Firststep,
            Secondstep,
            Thirdstep,
            Forthstep,
            StepProgress
        },

        props: {
            orderId: {
                type: Number|String,
                required: true
            }
        },

        computed: {


            _currentStep () {
                return this.$store.getters.getCurrentStep
            },

            _stepView () {

                switch( this.$store.getters.getCurrentStep ){

                    case 1:
                        return 'firststep'
                    case 2:
                        return 'secondstep'
                    case 3:
                        return 'thirdstep'
                    case 4:
                        return 'forthstep'
                }
            },
        },

        methods: {

            _abbort () {
                this.$swal({
                    text: 'Assistent wird beendet..',
                    closeOnClickOutside: false,
                    closeOnEsc: false,
                    buttons: false,
                })

                setTimeout(() => {
                    this.$swal.close()
                    this.$store.commit('resetWizard')
                    this.$emit('abbort')
                },1000 )
            },

            _stepdone () {

                this.$store.commit('incrementStep')
            }
        },

        beforeMount() {

            // Set current orderId to wizardstore
            this.$store.commit('setCurrentOrderIs', this.orderId)

            // Set customerId
            this.$store.commit('setCustomerId',   this.$store.getters.getUserData.id )

            // Set customer fullname
            this.$store.commit('setCustomerName', this.$store.getters.getUserData.fullName )

            // Set customer email
            this.$store.commit('setCustomerMail', this.$store.getters.getUserData.email )
        }
    }
</script>

<style>

</style>